








































import { Component, Prop, Vue } from 'vue-property-decorator';
import Input from '@shared/components/forms/inputs/input/input.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import { resourceAccessFieldConfig } from '@access-control/config/access_point_options';
import MultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import { ResourceAccessConfigurationInterface } from '@access-control/interfaces/access-point';

@Component({
  name: 'bc-resource-access-configuration',
  components: {
    'bc-input': Input,
    'bc-select': Select,
    'bc-entity-select': EntitySelect,
    'bc-multi-select': MultiSelect,
  },
})
export default class ResourceAccessConfiguration extends Vue {
  @Prop({
    type: Object,
    required: true,
  })
  readonly value: ResourceAccessConfigurationInterface;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: Number }) readonly accessPointId: number;
  @Prop({ type: Object, required: true }) readonly errorsObject!: any;
  @Prop({ type: Array, required: true }) readonly availableResources!: any;

  // LIFECYCLE

  // DATA

  // COMPUTED
  get fieldsConfig() {
    return resourceAccessFieldConfig;
  }

  get formModel(): ResourceAccessConfigurationInterface {
    return this.value;
  }
  set formModel(value) {
    this.$emit('input', value);
  }

  // METHODS
  clickOnDelete() {
    this.$emit('click-on-delete');
  }
}
